export default "__VITE_ASSET__CCOKfCn0__"